import React, { useState } from 'react';
import { useTheme } from './ThemeProvider';

/**
 * ThemeSettings — inline card for the Profile page
 * Shows theme swatches the user can tap to switch instantly.
 */
export default function ThemeSettings() {
  const { themeId, setTheme, themes } = useTheme();
  const [expanded, setExpanded] = useState(false);

  const themeList = Object.values(themes);
  const current = themes[themeId];

  return (
    <div>
      {/* Current theme + expand toggle */}
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        style={{
          width: '100%',
          padding: 0,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          color: 'var(--text-primary)',
          fontSize: '14px'
        }}
      >
        <span style={{ fontSize: '18px' }}>{current.emoji}</span>
        <span style={{ flex: 1, textAlign: 'left', fontWeight: 500 }}>
          {current.name}
          <span style={{ color: 'var(--text-muted)', fontWeight: 400, marginLeft: '6px', fontSize: '12px' }}>
            {current.description}
          </span>
        </span>
        <span style={{
          fontSize: '18px',
          transition: 'transform 0.2s',
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'
        }}>▾</span>
      </button>

      {/* Theme picker grid */}
      {expanded && (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '10px',
          marginTop: '16px',
          animation: 'fadeIn 0.25s ease-out'
        }}>
          {themeList.map((t) => {
            const isActive = t.id === themeId;
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => setTheme(t.id)}
                style={{
                  padding: '12px 8px',
                  borderRadius: 'var(--radius-md)',
                  border: isActive 
                    ? `2px solid ${t.vars['--primary']}` 
                    : '2px solid var(--border)',
                  background: isActive 
                    ? t.vars['--surface-dim'] || t.vars['--surface']
                    : 'var(--surface)',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s',
                  position: 'relative'
                }}
              >
                {/* Active check */}
                {isActive && (
                  <div style={{
                    position: 'absolute',
                    top: '4px',
                    right: '4px',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    background: t.vars['--primary'],
                    color: '#fff',
                    fontSize: '11px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700
                  }}>✓</div>
                )}

                {/* Preview swatch */}
                <div style={{
                  display: 'flex',
                  width: '100%',
                  height: '28px',
                  borderRadius: '6px',
                  overflow: 'hidden',
                  border: '1px solid rgba(0,0,0,0.08)'
                }}>
                  {t.preview.map((color, i) => (
                    <div key={i} style={{
                      flex: 1,
                      background: color
                    }} />
                  ))}
                </div>

                {/* Label */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '15px', lineHeight: 1 }}>{t.emoji}</div>
                  <div style={{
                    fontSize: '11px',
                    fontWeight: isActive ? 700 : 500,
                    color: isActive ? t.vars['--primary'] : 'var(--text-secondary)',
                    marginTop: '2px'
                  }}>{t.name}</div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
